import { Box, Flex, IconButton, useDisclosure, Badge, Image, Text, Modal, ModalOverlay, ModalContent, ModalHeader, ModalCloseButton, ModalBody, Input, ModalFooter, Button, Tooltip, Menu, MenuButton, MenuList, MenuItem, InputGroup, InputLeftElement, Popover, PopoverTrigger, PopoverContent, PopoverCloseButton, PopoverBody, Grid, GridItem } from "@chakra-ui/react";
import MyDiv from "./meetingsManagementList.style";
import { CalendarIcon, DeleteIcon, EditIcon, HamburgerIcon, RepeatIcon, Search2Icon, ViewIcon } from "@chakra-ui/icons";
import UploadLogo from "../../../../assets/images/UploadLogo.svg";
import { ParticipantsModal, UploadMomModal } from "./components";
import { AlertCard, CustomPagination, CustomTable, CustomToast, FilterPopover } from "../../../../components";
import { Column } from "../../../../components/CustomTable/customTable";
import { useState } from "react";
import { useFetch } from "../../../../hooks/useFetch";
import { showDate } from "../../../../utilities/helper";
import { useAuth } from "../../../../hooks/useAuth";
import FilterIcon from '../../../../assets/images/Filter.svg';
import SortIcon from '../../../../assets/images/SortIcon.svg';
import { IFilterOptions } from "../../../../components/FilterCard/filterCard";
import Calendar from "react-calendar";

const sortOptions = ["Newest First", "Oldest First", "Title A-Z", "Title Z-A"];
const sortMapping: Record<string, { field: string; order: number }> = {
    "Newest First": { field: "id", order: -1 },
    "Oldest First": { field: "id", order: 1 },
    "Title A-Z": { field: "title", order: 1 },
    "Title Z-A": { field: "title", order: -1 },
};

interface meetingProps {
    meetingData: any[];
    totalCount: number;
    reloadMeetings: () => void;
    onOpenParticipants: (meetingId: number, status: string) => void;
    participants: any[];
    participantsModal: any;
    confirmCancelMeeting: () => void;
    confirmSyncAttendance: () => void;
    setCancelConfirm: any;
    cancelConfirm: any;
    setSyncAttendanceConfirm: any;
    syncAttendanceConfirm: any;
    attendanceModal: any;
    attendanceData: any[];
    selectedMeetingId: any;
    setSelectedMeetingId: any;
    meetingStatus: string;
    setQuery: any;
    query: any;
    setSearch: React.Dispatch<React.SetStateAction<string>>;
    filter: IFilterOptions;
}

const MeetingsManagementList = ({
    meetingData, totalCount, reloadMeetings, onOpenParticipants, participants, participantsModal,
    confirmCancelMeeting, setCancelConfirm, cancelConfirm,
    confirmSyncAttendance, setSyncAttendanceConfirm, syncAttendanceConfirm,
    attendanceModal, attendanceData, selectedMeetingId, setSelectedMeetingId,
    meetingStatus, setQuery, query, setSearch, filter
}: meetingProps) => {
    const { addToast } = CustomToast();
    const { fetchApi } = useFetch(addToast);
    const { hasPermission } = useAuth();
    const uploadModal = useDisclosure();
    const rescheduleModal = useDisclosure();
    const sortPopover = useDisclosure();
    const { onClose } = useDisclosure();


    const [rescheduleData, setRescheduleData] = useState({ newDate: "", startTime: "", endTime: "" });
    const joinModal = useDisclosure();
    const [joinData, setJoinData] = useState<{ meetingId: number | null; meetingLink: string | null; title?: string }>({ meetingId: null, meetingLink: null });
    const [joining, setJoining] = useState(false);
    const [rescheduleLoading, setRescheduleLoading] = useState(false);
    const [acceptanceLoading, setAcceptanceLoading] = useState<number | null>(null);
    const [declineModal, setDeclineModal] = useState<{ isOpen: boolean; meetingId: number | null }>({ isOpen: false, meetingId: null });
    const [declineReason, setDeclineReason] = useState("");
    const [selected, setSelected] = useState<string>("");
    const [selectedDate, setSelectedDate] = useState<Date | null>(null);
    const calendarPopover = useDisclosure();

    const [alertConfig, setAlertConfig] = useState<any>(null);
    const [availableUsers, setAvailableUsers] = useState<any[]>([]);
    const [conflictUsers, setConflictUsers] = useState<any[]>([]);

    const pageCount = Math.ceil(totalCount / query.lazyParams.rows);

    const handlePageClick = ({ selected }: { selected: number }) => {
        setQuery((prev: { lazyParams: { rows: number; }; }) => {
            const updatedParams = {
                ...prev.lazyParams,
                page: selected,
                first: selected * prev.lazyParams.rows,
            };
            return { ...prev, lazyParams: updatedParams };
        });
    };

    const setRowsPerPage = (rows: number) => {
        setQuery((prev: { lazyParams: any; }) => {
            const updatedParams = {
                ...prev.lazyParams,
                rows,
                page: 0,
                first: 0,
            };
            return { ...prev, lazyParams: updatedParams };
        });
    };

    const handleSelect = (option: string) => {
        setSelected(option);
        const sortConfig = sortMapping[option];
        if (sortConfig) {
            setQuery((prev: any) => ({
                ...prev,
                lazyParams: {
                    ...prev.lazyParams,
                    sortField: sortConfig.field,
                    sortOrder: sortConfig.order,
                    page: 0,
                    first: 0
                }
            }));
        }
        sortPopover.onClose();
    };

    const getStatusColor = (status: string) => {
        switch (status) {
            case "Completed": return "green";
            case "Running": return "blue";
            case "Not Yet Started": return "gray";
            default: return "gray";
        }
    };

    const stripHtml = (html: string) => {
        const div = document.createElement("div");
        div.innerHTML = html;
        return div.textContent || div.innerText || "";
    };

    const handleJoinMeeting = async () => {
        if (!joinData.meetingId || !joinData.meetingLink) return;
        setJoining(true);
        try {
            const response = await fetchApi("Meetings/mark-join-status", "POST", {
                meetingId: joinData.meetingId,
                Attendance_Status: "Joined"
            });
            if (response) window.open(joinData.meetingLink, "_blank");
        } finally {
            setJoining(false);
            joinModal.onClose();
        }
    };

    const handleDeclineMeeting = async () => {
        if (!joinData.meetingId) return;
        setJoining(true);
        try {
            const response = await fetchApi("Meetings/mark-join-status", "POST", {
                meetingId: joinData.meetingId,
                Attendance_Status: "Declined"
            });
            if (response) reloadMeetings();
        } finally {
            setJoining(false);
            joinModal.onClose();
        }
    };

    const handleReschedule = async () => {
        if (!rescheduleData.newDate) { addToast({ message: "Please fill Meeting Date", status: "error" }); return; }
        if (!rescheduleData.startTime) { addToast({ message: "Please fill Start Time", status: "error" }); return; }
        if (!rescheduleData.endTime) { addToast({ message: "Please fill End Time", status: "error" }); return; }

        const now = new Date();
        const selected = new Date(`${rescheduleData.newDate}T${rescheduleData.startTime}`);

        if (selected < now) {
            addToast({ message: "Past date/time not allowed", status: "error" });
            return;
        }

        if (rescheduleData.endTime <= rescheduleData.startTime) {
            addToast({ message: "End time must be greater than start time", status: "error" });
            return;
        }

        const timeZoneId = Intl.DateTimeFormat().resolvedOptions().timeZone;



        const meeting = meetingData.find(m => m.id === selectedMeetingId);

        console.log(meetingData);

        const response = await fetchApi(`Meetings/checkAvailability?meeting_Id=${meeting?.id}`, "POST", {
            participants: meeting?.participants || [],
            meetingDate: rescheduleData.newDate,
            startTime: `${rescheduleData.startTime}:00`,
            endTime: `${rescheduleData.endTime}:00`,
            timeZoneId
        });

        if (response) {
            setAvailableUsers(response.available || []);
            setConflictUsers(response.conflict || []);

            if ((response.conflict || []).length > 0) {
                setAlertConfig({
                    type: "RESCHEDULE_CONFLICT",
                    description: `${response.conflict.length} participant(s) have conflicts. Do you want to reschedule anyway?`,
                    colorScheme: "red"
                });
                return;
            }
        }

        // setRescheduleLoading(true);
        // try {
        //     const timeZoneId = Intl.DateTimeFormat().resolvedOptions().timeZone;

        //     const response = await fetchApi(`Meetings/reschedule-meeting/${selectedMeetingId}`, "PUT", {
        //         newDate: rescheduleData.newDate,
        //         startTime: `${rescheduleData.startTime}:00`,
        //         endTime: `${rescheduleData.endTime}:00`,
        //         timeZoneId: timeZoneId
        //     });
        //     if (response) {
        //         addToast({ message: "Meeting rescheduled successfully", status: "success" });
        //         setRescheduleData({ newDate: "", startTime: "", endTime: "" });
        //         rescheduleModal.onClose();
        //         reloadMeetings();
        //     }
        // } finally {
        //     setRescheduleLoading(false);
        // }

        proceedReschedule();
    };


    const proceedReschedule = async () => {
        setRescheduleLoading(true);
        try {
            const timeZoneId = Intl.DateTimeFormat().resolvedOptions().timeZone;

            const response = await fetchApi(
                `Meetings/reschedule-meeting/${selectedMeetingId}`,
                "PUT",
                {
                    newDate: rescheduleData.newDate,
                    startTime: `${rescheduleData.startTime}:00`,
                    endTime: `${rescheduleData.endTime}:00`,
                    timeZoneId
                }
            );

            if (response) {
                addToast({ message: "Meeting rescheduled successfully", status: "success" });
                setRescheduleData({ newDate: "", startTime: "", endTime: "" });
                rescheduleModal.onClose();
                reloadMeetings();
            }
        } finally {
            setRescheduleLoading(false);
        }
    };

    const handleAcceptance = async (meetingId: number, status: "Accepted" | "Declined") => {
        if (status === "Declined") {
            setDeclineModal({ isOpen: true, meetingId });
            return;
        }
        setAcceptanceLoading(meetingId);
        try {
            const response = await fetchApi("Meetings/meeting-acceptance", "PUT", {
                meetingId, status, declineReason: null
            });
            if (response) {
                addToast({ message: "Meeting accepted successfully", status: "success" });
                reloadMeetings();
            }
        } finally {
            setAcceptanceLoading(null);
        }
    };

    const handleConfirmDecline = async () => {
        if (!declineReason.trim()) {
            addToast({ message: "Please provide a reason for declining", status: "error" });
            return;
        }
        if (!declineModal.meetingId) return;
        setAcceptanceLoading(declineModal.meetingId);
        try {
            const response = await fetchApi("Meetings/meeting-acceptance", "PUT", {
                meetingId: declineModal.meetingId,
                status: "Declined",
                declineReason: declineReason.trim()
            });
            if (response) {
                addToast({ message: "Meeting declined successfully", status: "success" });
                setDeclineReason("");
                setDeclineModal({ isOpen: false, meetingId: null });
                reloadMeetings();
            }
        } finally {
            setAcceptanceLoading(null);
        }
    };

    const today = new Date().toISOString().split("T")[0];


    return (
        <MyDiv>
            <Box className="table_wrapper" mt={2}>
                <Flex justify="flex-end" align="center" gap={2} mb={3} flexWrap="wrap">
                    <InputGroup width="250px" height="25px">
                        <InputLeftElement pointerEvents="none">
                            <Search2Icon color="rgba(102, 112, 133, 1)" />
                        </InputLeftElement>
                        <Input type="text" className="font-poppins text_regular text_md" placeholder="Search title or description...." onChange={(e) => setSearch(e.target.value)} />
                    </InputGroup>
                    <Flex mt={3} gap={2}>
                        <Popover isOpen={calendarPopover.isOpen} onOpen={calendarPopover.onOpen} onClose={calendarPopover.onClose} placement="bottom-end"  >
                            <PopoverTrigger>
                                <Button leftIcon={<CalendarIcon />} variant="outline" size="md" className="font-poppins text_sm text_regular">
                                    {selectedDate ? selectedDate.toDateString() : "Pick a Date"}
                                </Button>
                            </PopoverTrigger>
                            <PopoverContent w="auto">
                                <PopoverBody p={2} display="flex" flexDirection="column" alignItems="center" gap={2}>
                                    <Calendar value={selectedDate} onChange={(value) => {
                                        if (value instanceof Date) {
                                            setSelectedDate(value);
                                            const formatted = `${value.getFullYear()}-${String(value.getMonth() + 1).padStart(2, "0")}-${String(value.getDate()).padStart(2, "0")}`;
                                            setQuery((prev: any) => ({
                                                ...prev,
                                                filter: { ...prev.filter, Date: formatted },
                                                lazyParams: { ...prev.lazyParams, page: 0, first: 0 }
                                            }));
                                            calendarPopover.onClose();
                                        }
                                    }}
                                    />
                                    {selectedDate && (
                                        <Button size="xs" variant="ghost" colorScheme="red" width="full"
                                            onClick={() => {
                                                setSelectedDate(null);
                                                setQuery((prev: any) => {
                                                    const newFilter = { ...prev.filter };
                                                    delete newFilter.Date;
                                                    return { ...prev, filter: newFilter, lazyParams: { ...prev.lazyParams, page: 0, first: 0 } };
                                                });
                                                calendarPopover.onClose();
                                            }}
                                        >
                                            Clear Date
                                        </Button>
                                    )}
                                </PopoverBody>
                            </PopoverContent>
                        </Popover>
                        <Popover placement="bottom-end" closeOnBlur>
                            <PopoverTrigger>
                                <Image src={FilterIcon} alt="Filter" className='icon_btn' />
                            </PopoverTrigger>
                            <FilterPopover filter={filter} onApplyFilter={(filters) => {
                                const _filter: Record<string, number[]> = {};
                                Object.keys(filters).forEach((key) => {
                                    if (filters[key].length > 0) {
                                        _filter[key.replace(" ", "")] = filters[key];
                                    }
                                });
                                setQuery((prev: any) => ({ ...prev, filter: { ..._filter }, lazyParams: { ...prev.lazyParams, page: 0, first: 0 } }));
                                onClose();
                            }}

                            />
                        </Popover>
                        <Popover placement="bottom-end" closeOnBlur>
                            <PopoverTrigger>
                                <Image src={SortIcon} alt="Sort" className="icon_btn" />
                            </PopoverTrigger>
                            <PopoverContent w="270px" borderRadius="10px" boxShadow="md" textAlign={'center'}>
                                <Box px={4} py={2} borderBottom="1px solid #eee">
                                    <Text className='font-poppins text_sm text_medium' textAlign="center" color={"#00000080"}>Sort By</Text>
                                    <PopoverCloseButton top="8px" right="12px" />
                                </Box>
                                <PopoverBody p={0}>
                                    {sortOptions.map((option) => (
                                        <Box key={option} px={4} py={2} cursor="pointer" bg={selected === option ? '#EBEBEB' : 'white'} _hover={{ bg: '#EBEBEB' }} onClick={() => handleSelect(option)}>
                                            <Text className='font-poppins font_dark' fontSize="14px" fontWeight={selected === option ? '500px' : '500px'}>{option}</Text>
                                        </Box>
                                    ))}
                                </PopoverBody>
                            </PopoverContent>
                        </Popover>
                    </Flex>
                </Flex>

                <Grid className="grid_container">
                    <GridItem colSpan={12}>
                        <CustomTable value={meetingData} emptyMessage="No data found">
                            <Column header="Title" body={(data: any) => {
                                const cleanText = stripHtml(data.title || "");
                                const isLong = cleanText.length > 30;
                                const displayText = isLong ? cleanText.substring(0, 30) + "..." : cleanText;
                                return (
                                    <Tooltip label={<Box dangerouslySetInnerHTML={{ __html: data.title }} />}
                                        hasArrow placement="top-start" isDisabled={!isLong}
                                        bg="gray.700" color="white" fontSize="sm" borderRadius="md">
                                        <Text maxW="250px" whiteSpace="nowrap" overflow="hidden"
                                            textOverflow="ellipsis" cursor={isLong ? "pointer" : "default"}>
                                            {displayText}
                                        </Text>
                                    </Tooltip>
                                );
                            }} />
                            <Column header="Description" body={(data: any) => {
                                const cleanText = stripHtml(data.description || "");
                                const isLong = cleanText.length > 30;
                                const displayText = isLong ? cleanText.substring(0, 30) + "..." : cleanText;
                                return (
                                    <Tooltip label={<Box dangerouslySetInnerHTML={{ __html: data.description }} />}
                                        hasArrow placement="top-start" isDisabled={!isLong}
                                        bg="gray.700" color="white" fontSize="sm" borderRadius="md">
                                        <Text maxW="250px" whiteSpace="nowrap" overflow="hidden"
                                            textOverflow="ellipsis" cursor={isLong ? "pointer" : "default"}>
                                            {displayText}
                                        </Text>
                                    </Tooltip>
                                );
                            }} />
                            <Column header="Meeting Date" body={(data: any) => showDate(data.date)} />
                            <Column header="Meeting Time" body={(data: any) => (
                                <Text>{data.startTime?.slice(0, 5)} - {data.endTime?.slice(0, 5)}</Text>
                            )} />
                            <Column header="Meeting Link / Location" body={(data: any) => {
                                const isOnline = data.mode === "Online";
                                const myAcceptance = data.myAcceptanceStatus;
                                const myDeclineReason = data.myDeclineReason;
                                const myJoinStatus = data.myJoinStatus;
                                if (myJoinStatus === "Joined") {

                                    return (
                                        <Badge className="font-poppins text_md text_md" colorScheme="green" cursor="default">Joined</Badge>
                                    );
                                }

                                if (myAcceptance === null || myAcceptance === undefined) {
                                    if (isOnline && data.meetingLink) {
                                        return (
                                            <Text color={data.canJoinMeeting && data.status === "Running" ? "blue.500" : "gray.400"}
                                                fontWeight="500"
                                                _hover={data.canJoinMeeting && data.status === "Running" ? { textDecoration: "underline", color: "blue.600" } : {}}
                                                cursor={data.canJoinMeeting && data.status === "Running" ? "pointer" : "not-allowed"}
                                                opacity={data.canJoinMeeting && data.status === "Running" ? 1 : 0.6}
                                                onClick={() => {
                                                    if (!data.canJoinMeeting || data.status !== "Running") return;
                                                    setJoinData({ meetingId: data.id, meetingLink: data.meetingLink, title: data.title });
                                                    joinModal.onOpen();
                                                }}
                                            >
                                                {data.meetingLink}
                                            </Text>
                                        );
                                    }
                                    return <Text color="gray.700">📍 {data.roomNo}</Text>;
                                }

                                if (myAcceptance === "Pending") {
                                    if (data.status === "Completed") {
                                        return (
                                            <Text className="font-poppins text_md text_md" color={"red.500"}>No Action Taken</Text>
                                        );
                                    }
                                    return (
                                        <Flex gap={2}>
                                            <Button size="xs" colorScheme="green" isLoading={acceptanceLoading === data.id} onClick={() => handleAcceptance(data.id, "Accepted")} > Accept </Button>
                                            <Button size="xs" colorScheme="red" variant="outline" isLoading={acceptanceLoading === data.id} onClick={() => handleAcceptance(data.id, "Declined")} >Decline</Button>
                                        </Flex>
                                    );
                                }

                                if (myAcceptance === "Declined") {
                                    return (
                                        <Tooltip label={myDeclineReason || "No reason provided"} hasArrow placement="top">
                                            <Badge colorScheme="red" cursor="default">Declined Meeting Invitation</Badge>
                                        </Tooltip>
                                    );
                                }

                                if (myAcceptance === "Accepted") {
                                    if (isOnline && data.meetingLink) {

                                        const isRunning = data.status === "Running";

                                        return (
                                            <Text color={isRunning ? "blue.500" : "gray.400"} fontWeight="500"
                                                _hover={isRunning ? { textDecoration: "underline", color: "blue.600" } : {}}
                                                cursor={isRunning ? "pointer" : "not-allowed"}
                                                opacity={isRunning ? 1 : 0.6}
                                                onClick={() => {
                                                    if (!isRunning) return;
                                                    setJoinData({ meetingId: data.id, meetingLink: data.meetingLink, title: data.title });
                                                    joinModal.onOpen();
                                                }}
                                            >
                                                {data.meetingLink}
                                            </Text>
                                        );
                                    }

                                    return <Text color="gray.700">📍 {data.roomNo}</Text>;
                                }

                                return <Text color="gray.400">—</Text>;
                            }} />
                            <Column header="No. of Participants" field="participant_Count" />
                            <Column header="Status" body={(data: any) => (
                                <Badge colorScheme={getStatusColor(data.status)}>{data.status}</Badge>
                            )} />
                            <Column header="Created By" field="created_By" />
                            <Column header="Action" body={(data: any) => (
                                <Menu placement="left-start">
                                    <MenuButton as={IconButton} icon={<HamburgerIcon />} size="sm" variant="ghost" aria-label="Actions" />
                                    <MenuList fontSize="sm">
                                        {/* <MenuItem icon={<Image src={UploadLogo} w="14px" />}
                                    onClick={() => { setSelectedMeetingId(data.id); uploadModal.onOpen(); }}>
                                    Upload MOM
                                </MenuItem> */}
                                        <MenuItem icon={<ViewIcon />} onClick={() => onOpenParticipants(data.id, data.status)}>
                                            View Participants
                                        </MenuItem>
                                        {hasPermission("MeetingsManagement", "Create_Meeting") && data.status !== "Completed" && data.status !== "Running" && (
                                            <MenuItem icon={<EditIcon />} onClick={() => { setSelectedMeetingId(data.id); rescheduleModal.onOpen(); }}>
                                                Reschedule
                                            </MenuItem>
                                        )}
                                        {hasPermission("MeetingsManagement", "Create_Meeting") && data.status !== "Completed" && data.status !== "Running" && (
                                            <MenuItem icon={<DeleteIcon />} onClick={() => setCancelConfirm({ meetingId: data.id, isOpen: true })}>
                                                Cancel Meeting
                                            </MenuItem>
                                        )}
                                        {hasPermission("MeetingsManagement", "Sync_Attendance") && data.status === "Completed" && (
                                            <MenuItem icon={<RepeatIcon />} onClick={() => setSyncAttendanceConfirm({ meetingId: data.id, isOpen: true })}>
                                                Sync Attendance
                                            </MenuItem>
                                        )}
                                    </MenuList>
                                </Menu>
                            )} />
                        </CustomTable>

                    </GridItem>
                </Grid>
                <CustomPagination pageCount={pageCount} handlePageClick={handlePageClick} rowsPerPage={query.lazyParams.rows} setRowsPerPage={setRowsPerPage} totalRecords={totalCount} currentPage={query.lazyParams.page} rowsPerPageOptions={[20, 50, 200, 500]} />
            </Box>

            <Modal isOpen={rescheduleModal.isOpen} onClose={rescheduleModal.onClose} isCentered>
                <ModalOverlay />
                <ModalContent>
                    <ModalHeader>Reschedule Meeting</ModalHeader>
                    <ModalCloseButton />
                    <ModalBody>
                        <Flex direction="column" gap={3}>
                            <Input type="date" value={rescheduleData.newDate} min={today}
                                onChange={(e) => setRescheduleData({ ...rescheduleData, newDate: e.target.value })} />
                            <Input type="time" value={rescheduleData.startTime}
                                onChange={(e) => setRescheduleData({ ...rescheduleData, startTime: e.target.value })} />
                            <Input type="time" value={rescheduleData.endTime}
                                onChange={(e) => setRescheduleData({ ...rescheduleData, endTime: e.target.value })} />
                        </Flex>
                    </ModalBody>
                    <ModalFooter>
                        <Button colorScheme="green" isLoading={rescheduleLoading} onClick={handleReschedule}>Save</Button>
                    </ModalFooter>
                </ModalContent>
            </Modal>

            {/* Attendance Modal */}
            <Modal isOpen={attendanceModal.isOpen} onClose={attendanceModal.onClose} size="xl" isCentered>
                <ModalOverlay />
                <ModalContent maxH="75vh">
                    <ModalHeader textAlign="center">Meeting Attendance</ModalHeader>
                    <ModalCloseButton />
                    <ModalBody overflowY="auto">
                        {attendanceData.length === 0 ? (
                            <Text textAlign="center" color="gray.500">No attendance records found.</Text>
                        ) : (
                            <Box>
                                {attendanceData.map((a: any, index: number) => (
                                    <Flex key={index} justify="space-between" align="center" p={3} borderBottom="1px solid #eee">
                                        <Box>
                                            <Text fontWeight="600">{a.participant_Name}</Text>
                                            <Text fontSize="sm" color="gray.500">
                                                {a.join_Time?.slice(0, 5)} - {a.leave_Time?.slice(0, 5)}
                                            </Text>
                                        </Box>
                                        <Badge colorScheme={a.duration_Minutes > 0 ? "green" : "red"}>
                                            {a.duration_Minutes ?? 0} mins
                                        </Badge>
                                    </Flex>
                                ))}
                            </Box>
                        )}
                    </ModalBody>
                </ModalContent>
            </Modal>

            {/* Join Modal */}
            <Modal isOpen={joinModal.isOpen} onClose={joinModal.onClose} isCentered size="sm">
                <ModalOverlay />
                <ModalContent>
                    <ModalHeader textAlign="center">Join Meeting</ModalHeader>
                    <ModalCloseButton />
                    <ModalBody textAlign="center" py={6}>
                        <Text color="gray.600">Do you want to join this meeting now?</Text>
                    </ModalBody>
                    <ModalFooter justifyContent="center" gap={4}>
                        <Button colorScheme="green" onClick={handleJoinMeeting} isLoading={joining}>Join Meeting</Button>
                        <Button colorScheme="red" variant="outline" onClick={handleDeclineMeeting} isLoading={joining}>Decline</Button>
                    </ModalFooter>
                </ModalContent>
            </Modal>

            {/* Decline Reason Modal */}
            <Modal isOpen={declineModal.isOpen}
                onClose={() => { setDeclineModal({ isOpen: false, meetingId: null }); setDeclineReason(""); }}
                isCentered size="sm">
                <ModalOverlay />
                <ModalContent>
                    <ModalHeader>Decline Meeting</ModalHeader>
                    <ModalCloseButton />
                    <ModalBody>
                        <Text fontSize="sm" color="gray.600" mb={2}>Please provide a reason for declining:</Text>
                        <Input placeholder="Enter reason..." value={declineReason}
                            onChange={(e) => setDeclineReason(e.target.value)} />
                    </ModalBody>
                    <ModalFooter gap={2}>
                        <Button variant="outline"
                            onClick={() => { setDeclineModal({ isOpen: false, meetingId: null }); setDeclineReason(""); }}>
                            Cancel
                        </Button>
                        <Button colorScheme="red"
                            isLoading={acceptanceLoading === declineModal.meetingId}
                            onClick={handleConfirmDecline}>
                            Confirm Decline
                        </Button>
                    </ModalFooter>
                </ModalContent>
            </Modal>

            <AlertCard isOpen={cancelConfirm.isOpen}
                onClose={() => setCancelConfirm({ meetingId: null, isOpen: false })}
                onConfirm={confirmCancelMeeting}
                description="Are you sure you want to cancel this meeting? This action cannot be undone."
                colorScheme="red" />

            <AlertCard isOpen={syncAttendanceConfirm.isOpen}
                onClose={() => setSyncAttendanceConfirm({ meetingId: null, isOpen: false })}
                onConfirm={confirmSyncAttendance}
                description="Are you sure you want to sync attendance for this meeting?"
                colorScheme="green" />

            <UploadMomModal isOpen={uploadModal.isOpen} onClose={uploadModal.onClose} />

            <ParticipantsModal
                isOpen={participantsModal.isOpen}
                onClose={participantsModal.onClose}
                participants={participants}
                hasPermission={hasPermission}
                selectedMeetingId={selectedMeetingId}
                reloadParticipants={onOpenParticipants}
                meetingStatus={meetingStatus}
            />

            <AlertCard
                isOpen={!!alertConfig}
                onClose={() => setAlertConfig(null)}
                onConfirm={() => {
                    setAlertConfig(null);
                    proceedReschedule(); // ✅ continue anyway
                }}
                description={alertConfig?.description || ""}
                colorScheme={alertConfig?.colorScheme || "red"}
            />
        </MyDiv>
    );
};

export default MeetingsManagementList; 